<pla-custom-loader-box *ngIf="loadingTexts" [classes]="classes" [almostComplete]="almostComplete"
  (complete)="LoadComplete(1)" [loadingTexts]="loadingTexts" [car]="'AVENTADOR_SV'"
  [barColour]="'#E46400'"></pla-custom-loader-box>
